import { useState, useEffect } from "react";
import { useAuth } from "../context/AuthContext";
//FUERA del hook
const API_LARAVEL_URL =
  process.env.REACT_APP_API_URL || "http://localhost:8000/api";

const usePermissions = (menuSlug) => {
  const { user } = useAuth();
  const [permissions, setPermissions] = useState({
    can_view: false,
    can_create: false,
    can_edit: false,
    can_delete: false,
    can_view_evidencias: false,
    can_create_evidencias: false,
    can_edit_evidencias: false,
    can_delete_evidencias: false,
    loading: true,
  });

  useEffect(() => {
    const fetchPermissions = async () => {
      if (!user || !menuSlug) {
        setPermissions((prev) => ({ ...prev, loading: false }));
        return;
      }
      try {
        const token = localStorage.getItem("token");
        const response = await fetch(
          `${API_LARAVEL_URL}/permissions/${menuSlug}`,
          {
            headers: {
              "Content-Type": "application/json",
              Accept: "application/json",
              ...(token && { Authorization: `Bearer ${token}` }),
            },
          },
        );
        if (response.ok) {
          const data = await response.json();
          if (data.success) {
            setPermissions({
              can_view: data.data.can_view || false,
              can_create: data.data.can_create || false,
              can_edit: data.data.can_edit || false,
              can_delete: data.data.can_delete || false,
              can_view_evidencias: data.data.can_view_evidencias || false,
              can_create_evidencias: data.data.can_create_evidencias || false,
              can_edit_evidencias: data.data.can_edit_evidencias || false,
              can_delete_evidencias: data.data.can_delete_evidencias || false,
              loading: false,
            });
          }
        } else {
          setPermissions({
            can_view: false,
            can_create: false,
            can_edit: false,
            can_delete: false,
            can_view_evidencias: false,
            can_create_evidencias: false,
            can_edit_evidencias: false,
            can_delete_evidencias: false,
            loading: false,
          });
        }
      } catch (error) {
        setPermissions({
          can_view: false,
          can_create: false,
          can_edit: false,
          can_delete: false,
          can_view_evidencias: false,
          can_create_evidencias: false,
          can_edit_evidencias: false,
          can_delete_evidencias: false,
          loading: false,
        });
      }
    };
    fetchPermissions();
  }, [user, menuSlug]); // ← solo estas dos dependencias

  return permissions;
};
export default usePermissions;
